const API_BASE_URL =
    process.env.NODE_ENV === "production"
        ? "/api" // Use root URL in production
        : "http://localhost:8080/api"; // Use localhost in development

export default {
    API_BASE_URL,
    // COURSES_ENDPOINT: `${API_BASE_URL}/course`,
};
